import domtoimage from 'dom-to-image';

/**
 * Captura componente usando dom-to-image (mejor para styled-components)
 * @param {React.RefObject} componentRef - Referencia al componente 
 */
export const printComponent = (componentRef) => {
  const node = componentRef.current;
  if (!node) {
    console.error("Referencia no válida");
    return;
  }
  
  // Configuración mínima
  domtoimage.toPng(node, {
    quality: 0.95,
    bgcolor: '#ffffff',
  })
  .then(dataUrl => {
    const link = document.createElement('a');
    link.download = `FurnCIRCLE - ${Date.now()}.png`;
    link.href = dataUrl;
    link.click();
  })
  .catch(error => {
    console.error('Error al capturar:', error);
  });
};